import React from 'react';
import { XCircle } from 'lucide-react';
import { motion } from 'framer-motion';
const pains = ['Llegar a la primera consulta sin saber qué decir ni cómo presentarte.', "Sentir que los clientes dudan de vos porque sos 'nuevo' en el rubro.", 'No tener idea de dónde o cómo buscar tus primeros leads.', 'Sentir que la falta de experiencia te juega en contra en cada tasación.', 'Tener un WhatsApp desordenado, sin un sistema de seguimiento claro.', 'Ver pasar los meses, pagar la matrícula, y seguir sin tu primera venta.'];
export function ProblemAgitation() {
  return <section className="py-24 bg-brand-navy text-white px-6 lg:px-8" data-id="element-243">
      <div className="max-w-3xl mx-auto" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-245">
          <h2 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight" data-id="element-246">
            ¿Por qué la mayoría de los corredores nuevos abandonan el primer
            año?
          </h2>
          <p className="text-xl text-white/80 font-medium" data-id="element-247">
            No es por falta de ganas. Es por la falta de un sistema: leads que
            se queman, trámites manuales y nadie que te explique cómo conseguir
            tu primera cartera.
          </p>
        </motion.div>

        <div className="bg-white/5 rounded-3xl p-8 md:p-10 border border-white/10 backdrop-blur-sm mb-12" data-id="element-248">
          <ul className="space-y-6" data-id="element-249">
            {pains.map((pain, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4" data-id="element-250">
                <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-251" />
                <span className="text-lg text-white/90" data-id="element-252">{pain}</span>
              </motion.li>)}
          </ul>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-253">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-light" data-id="element-254">
            ¿Y si tu primera venta fuera más cerca de lo que pensás?
          </h3>
        </motion.div>
      </div>
    </section>;
}